import { render, staticRenderFns } from "./modalFbByTemplate.vue?vue&type=template&id=b8f0cd48&scoped=true"
import script from "./modalFbByTemplate.vue?vue&type=script&lang=js"
export * from "./modalFbByTemplate.vue?vue&type=script&lang=js"
import style0 from "./modalFbByTemplate.vue?vue&type=style&index=0&id=b8f0cd48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f0cd48",
  null
  
)

export default component.exports